import { reportRecoverableError } from '../core/diagnostics'

export interface TrackEvent {
  name: string
  props?: Record<string, string | number | boolean>
}

let endpoint: string | undefined
let queue: TrackEvent[] = []

export function init(analyticsEndpoint?: string): void {
  endpoint = analyticsEndpoint
  if (endpoint && queue.length) {
    queue.forEach(flush)
    queue = []
  }
}

function flush(event: TrackEvent): void {
  if (!endpoint) {
    queue.push(event)
    return
  }
  const payload = JSON.stringify({ ...event, ts: Date.now(), url: location.href })
  if (navigator.sendBeacon && navigator.sendBeacon(endpoint, payload)) {
    return
  }

  fetch(endpoint, { method: 'POST', body: payload, keepalive: true })
    .catch(error => reportRecoverableError('analytics delivery failed', error))
}

/** Tracks a page view. Call once per navigation. */
export function pageview(props?: TrackEvent['props']): void {
  flush({ name: 'pageview', props })
}

/** Tracks a discrete interaction (click, form submit, etc). */
export function track(name: string, props?: TrackEvent['props']): void {
  flush({ name, props })
}
